// extracted by mini-css-extract-plugin
export var modal = "_fu-0";